module.exports = __webpack_public_path__ + "static/media/app-warning.9db45cf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/app-warning.svg
// module id = 511
// module chunks = 0